import * as React from "react";
import type { SVGProps } from "react";

/**
 * Clock Icon - 时钟/最近游戏图标
 * Used for: Recently Played category
 */
const ClockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
  >
    <path d="M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4zm0 36c-8.837 0-16-7.163-16-16S15.163 8 24 8s16 7.163 16 16-7.163 16-16 16zm2-18V12h-4v12l10 6 2-3.464-8-4.536z" />
  </svg>
);

export default ClockIcon;

